import React from 'react';
import { Bot, RefreshCcw } from 'lucide-react';
import styles from '../styles/AIAssistant.module.css';
import { ActionIcon, Group, Text } from '../ui/primitives.js';

export type AIAssistantHeaderProps = {
  title: string;
  subtitle?: string;
  icon?: React.ReactNode;
  showReset?: boolean;
  onReset?: () => void;
  /** Slot for additional controls (e.g. model selector) rendered to the right of the title. */
  headerActions?: React.ReactNode;
};

export function AIAssistantHeader({
  title,
  subtitle,
  icon,
  showReset = false,
  onReset,
  headerActions,
}: AIAssistantHeaderProps) {
  return (
    <div className={styles.header}>
      <Group justify="space-between" align="center" wrap="nowrap">
        <Group gap="sm" align="center" className={styles.headerLeft}>
          <div className={styles.headerIcon}>
            {icon ?? <Bot size={18} />}
          </div>
          <div className={styles.headerTitleBlock}>
            <Text className={styles.headerTitle}>{title}</Text>
            {subtitle ? (
              <Text className={styles.headerSubtitle}>{subtitle}</Text>
            ) : null}
          </div>
        </Group>
        <Group gap="xs" align="center" className={styles.headerRight}>
          {headerActions}
          {showReset ? (
            <ActionIcon
              variant="subtle"
              color="gray"
              size="sm"
              onClick={onReset}
              data-testid="ai-new-conversation"
              aria-label="New conversation"
            >
              <RefreshCcw size={16} />
            </ActionIcon>
          ) : null}
        </Group>
      </Group>
    </div>
  );
}
